import { BpmnModel, BpmnModelHelper, ExtensionMethod, FlowElement, ServiceTask } from "@edp-pmf/bpmn-model";
import { CreationHumanPerformerImpl } from "./CreationHumanPerformerImpl";
import { BillCreationType } from "./BillCreationType";
import { WFStartMode } from "./WFStartMode";
import { DataSourceType, HumanPerformerImpl } from "@edp-bpm/bpmn-common-model";

export class BillNodeActivity extends ServiceTask {
  static Clr_Type_ID: string = "bpm.AifBillNodeActivity";
  static MEXTAG: string = 'bpm.AifBillNodeActivity';
  ClrTypeID: string = BillNodeActivity.Clr_Type_ID;
  /**
   * 当前单据
   */
  currentDocumentTypeId: string;
  currentDocumentTypeName: string;
  currentVoId: string;
  currentVoName: string;
  currentDataModelType: DataSourceType = DataSourceType.VO;
  currentDataModelId: string;
  currentDataModelName: string;

  /**
   * 审批流程相关
   */
  wfConfig: boolean;
  calledBizDefKey: string;
  calledElement: string;
  wfStartMode = WFStartMode.IMMEDIATELY;
  /**
   * 工作流发起人
   */
  humanPerformers4submitWfProcess: HumanPerformerImpl[] = [];

  /**
   * 推单管理员
   */
  humanPerformers4Push: CreationHumanPerformerImpl[] = [];
  /**
   * 拉单管理员
   */
  humanPerformers4Pull: CreationHumanPerformerImpl[] = [];

  constructor(model: BpmnModel) {
    super(model);
  }

  NewInstance(): BillNodeActivity {
    return new BillNodeActivity(this.Model)
  }

  protected ResetBeforeLoadFrom(): void {
    super.ResetBeforeLoadFrom();
    this.currentDocumentTypeId = null;
    this.currentDocumentTypeName = null;
    this.currentVoId = null;
    this.currentVoName = null;
    this.currentDataModelType = DataSourceType.VO;
    this.currentDataModelId = null;
    this.currentDataModelName = null;
    this.wfConfig = false;
    this.calledBizDefKey = null;
    this.calledElement = null;
    this.humanPerformers4Push = [];
    this.humanPerformers4Pull = [];
    this.wfStartMode = WFStartMode.IMMEDIATELY;
    this.humanPerformers4submitWfProcess = [];
  }

  public ConvertToJsonObject(): {} {
    this.beforeSerialize();
    const obj = super.ConvertToJsonObject();

    ExtensionMethod.SetAttributeValue(obj, "currentDocumentTypeId", this.currentDocumentTypeId);
    ExtensionMethod.SetAttributeValue(obj, "currentDocumentTypeName", this.currentDocumentTypeName);
    ExtensionMethod.SetAttributeValue(obj, "currentVoId", this.currentVoId);
    ExtensionMethod.SetAttributeValue(obj, "currentVoName", this.currentVoName);
    ExtensionMethod.SetAttributeValue(obj, "currentDataModelType", this.currentDataModelType);
    ExtensionMethod.SetAttributeValue(obj, "currentDataModelId", this.currentDataModelId);
    ExtensionMethod.SetAttributeValue(obj, "currentDataModelName", this.currentDataModelName);
    ExtensionMethod.SetAttributeValue(obj, "wfConfig", this.wfConfig);
    ExtensionMethod.SetAttributeValue(obj, "calledBizDefKey", this.calledBizDefKey);
    ExtensionMethod.SetAttributeValue(obj, "calledElement", this.calledElement);
    ExtensionMethod.SetAttributeValue(obj, "wfStartMode", this.wfStartMode);

    return obj;
  }

  public LoadFromJsonObject(obj: {}): void {
    super.LoadFromJsonObject(obj);

    this.currentDocumentTypeId = ExtensionMethod.GetAttributeValue4String(obj, "currentDocumentTypeId");
    this.currentDocumentTypeName = ExtensionMethod.GetAttributeValue4String(obj, "currentDocumentTypeName");
    this.currentVoId = ExtensionMethod.GetAttributeValue4String(obj, "currentVoId");
    this.currentVoName = ExtensionMethod.GetAttributeValue4String(obj, "currentVoName");
    this.currentDataModelType = DataSourceType[ExtensionMethod.GetAttributeValue4String(obj, "currentDataModelType")];
    this.currentDataModelId = ExtensionMethod.GetAttributeValue4String(obj, "currentDataModelId");
    this.currentDataModelName = ExtensionMethod.GetAttributeValue4String(obj, "currentDataModelName");
    this.wfConfig = ExtensionMethod.GetAttributeValue4Boolean(obj, "wfConfig");
    this.calledBizDefKey = ExtensionMethod.GetAttributeValue4String(obj, "calledBizDefKey");
    this.calledElement = ExtensionMethod.GetAttributeValue4String(obj, "calledElement");
    this.wfStartMode = WFStartMode[ExtensionMethod.GetAttributeValue4String(obj, "wfStartMode")];

    this.afterDeserialize();
  }

  protected beforeSerialize() {
    if (this.humanPerformers4Push != null) {
      for (let humanPerformer of this.humanPerformers4Push) {
        this.RemoveResourceRole(humanPerformer.Id);
        this.AddResourceRole(humanPerformer);
      }
    }
    if (this.humanPerformers4Pull != null) {
      for (let humanPerformer of this.humanPerformers4Pull) {
        this.RemoveResourceRole(humanPerformer.Id);
        this.AddResourceRole(humanPerformer);
      }
    }
    if (this.humanPerformers4submitWfProcess != null) {
      for (let humanPerformer of this.humanPerformers4submitWfProcess) {
        this.RemoveResourceRole(humanPerformer.Id);
        this.AddResourceRole(humanPerformer);
      }
    }
  }

  protected afterDeserialize() {
    if (this.GetResourceRoles().length == 0) {
      return;
    }
    for (let role of this.GetResourceRoles()) {
      if (role instanceof CreationHumanPerformerImpl) {
        if (role.billCreationType == BillCreationType.PUSH) {
          this.humanPerformers4Push.push(role);
        } else if (role.billCreationType == BillCreationType.PULL) {
          this.humanPerformers4Pull.push(role);
        }
      } else {
        this.humanPerformers4submitWfProcess.push(role as HumanPerformerImpl);
      }
    }
  }

  clone(): BillNodeActivity {
    const clone = super.clone() as BillNodeActivity;

    clone.currentDocumentTypeId = this.currentDocumentTypeId;
    clone.currentDocumentTypeName = this.currentDocumentTypeName;
    clone.currentVoId = this.currentVoId;
    clone.currentVoName = this.currentVoName;
    clone.currentDataModelType = this.currentDataModelType;
    clone.currentDataModelId = this.currentDataModelId;
    clone.currentDataModelName = this.currentDataModelName;
    clone.wfConfig = this.wfConfig;
    clone.calledBizDefKey = this.calledBizDefKey;
    clone.calledElement = this.calledElement;
    clone.wfStartMode = this.wfStartMode;
    if (this.humanPerformers4Push != null) {
      clone.humanPerformers4Push = this.humanPerformers4Push.map(it => it.clone());
    }
    if (this.humanPerformers4Pull != null) {
      clone.humanPerformers4Pull = this.humanPerformers4Pull.map(it => it.clone());
    }
    if (this.humanPerformers4submitWfProcess != null) {
      clone.humanPerformers4submitWfProcess = this.humanPerformers4submitWfProcess.map(it => it.clone());
    }
    return clone;
  }
}

BpmnModelHelper.RegisterElementType(new BillNodeActivity(new BpmnModel()));
